import { CalendarList } from "./CalendarList";

export const CalendarPage = () => {
  return <CalendarList />;
};
